import { render, staticRenderFns } from "./mobileaccount.vue?vue&type=template&id=483f65e6&scoped=true"
import script from "./mobileaccount.vue?vue&type=script&lang=js"
export * from "./mobileaccount.vue?vue&type=script&lang=js"
import style0 from "./mobileaccount.vue?vue&type=style&index=0&id=483f65e6&prod&lang=scss&scoped=true"
import style1 from "./mobileaccount.vue?vue&type=style&index=1&id=483f65e6&prod&lang=css"
import style2 from "./mobileaccount.vue?vue&type=style&index=2&id=483f65e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f65e6",
  null
  
)

export default component.exports